import kdsLogo from '../../../public/logo1.png';
import { Button } from '@attain-sre/attain-design-system';
import {
  CLEARING_CACHE,
  CLEAR_CACHE_AND_RELOGIN,
  ERROR_BOUNDARY_MESSAGE,
  REDIRECTING,
  RETURN_TO_HOMEPAGE,
} from '../../content';
import { RESET_ALL_REDUCERS } from '../../redux/actions';
import { Routes } from '../../constants';
import { store } from 'redux/store';
import { useState } from 'react';
import * as Styled from './index.styles';

const ErrorMsg = () => {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [isClearingCache, setIsClearingCache] = useState(false);

  /*
   * Clear cache and redirect to login
   */
  const handleClearCacheAndRelogin = () => {
    try {
      setIsClearingCache(true);
      localStorage.clear();
      sessionStorage.clear();
      setTimeout(() => {
        window.location.href = Routes.LOGIN;
      }, 1000);
    } catch (error) {
      console.error('Error during cache clearing:', error);
      setIsClearingCache(false);
    }
  };

  /*
   * Reset all reducers and redirect to audience manager
   */
  const handleReturnHome = async () => {
    try {
      setIsRedirecting(true);
      await store.dispatch({ type: RESET_ALL_REDUCERS });
      setTimeout(() => {
        window.location.href = Routes.AUDIENCE_STUDIO;
      }, 1000);
    } catch (error) {
      console.error('Error during navigation:', error);
      setIsRedirecting(false);
    }
  };

  return (
    <Styled.Wrapper>
      <Styled.Logo src={kdsLogo} alt="ADS" />
      <Styled.Message>{ERROR_BOUNDARY_MESSAGE}</Styled.Message>
      <Styled.ButtonContainer>
        <Button
          variant="contained"
          onClick={handleReturnHome}
          disabled={isRedirecting}
        >
          {isRedirecting ? REDIRECTING : RETURN_TO_HOMEPAGE}
        </Button>
        <Button
          variant="outlined"
          onClick={handleClearCacheAndRelogin}
          disabled={isClearingCache}
        >
          {isClearingCache ? CLEARING_CACHE : CLEAR_CACHE_AND_RELOGIN}
        </Button>
      </Styled.ButtonContainer>
    </Styled.Wrapper>
  );
};

export default ErrorMsg;
